import React from 'react';
import { Box, Typography } from '@mui/material';
import NVDrawer from '../Drawer/Drawer';
// import NVDrawerLeft from '../Drawer/NVDrawerLeft';
// import NVDrawerRight from '../Drawer/NVDrawerRight';
import NVAppBar from '../Appbar';
import MainContent from '../MainContent/mainContent';

import { useMainFrameState } from '.';
import NVToolbar from '../Appbar/NVToolbar';
import Loading from '../../Loader';
import NVNotificationDrawer from '../Drawer/NVNotificationDrawer';
import NVBackdrop from '../../reusableUiComponent/NVBackdrop';
import NVSnackbar from '../../reusableUiComponent/NVSnackbar';
import NVPopover from '../../reusableUiComponent/NVPopover';
import SwipeableDrawerProvider from '../UISwipeableDrawer';

const Wrapper = props => {
  const {
    isToolbarOpen,
    isAppBar,
    isMainDrawer,
    isNotificationDrawer,
  } = useMainFrameState();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        {isMainDrawer && props?.firebaseUser && <NVDrawer />}
        {isNotificationDrawer && <NVNotificationDrawer />}
        {isAppBar && props?.firebaseUser && <NVAppBar />}
        {isToolbarOpen && <NVToolbar />}
        {<SwipeableDrawerProvider />}
        {/* {isBottomBar && props?.firebaseUser && <NVAppBar isBottom />} */}
        <NVSnackbar />
        <NVPopover />
        <React.Suspense fallback={<Loading isLoading noFade />}>
          <MainContent>{props.children}</MainContent>
        </React.Suspense>
      </Box>
    </>
  );
};

export default Wrapper;
